export { LogDecorator as Log } from './log.decorator';
export { LocalCache } from './local-cache.utils';



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/utils/index.ts